import { AccordionList } from "../../../../modules/content/components/AccordionList/AccordionList";
import { VelvetCommonContent } from "../../../../modules/content/components/VelvetCommonContent/VelvetCommonContent";
import { VelvetSection } from "../../../../modules/content/components/VelvetSection/VelvetSection";
import type { IAccordionBlockProps } from "./AccordionBlock.props";

export const AccordionBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  items,
  openBehavior,
  parentClass,
  spacing,
}: IAccordionBlockProps) => {
  if (!items?.length) return null;
  return (
    <VelvetSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="grid gap-16 lg:grid-cols-12 lg:gap-y-20">
        <VelvetCommonContent
          alignment={alignment}
          buttons={buttons}
          className="lg:col-span-8"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className="lg:col-span-9 lg:col-start-4">
          <AccordionList items={items} openBehavior={openBehavior} />
        </div>
      </div>
    </VelvetSection>
  );
};

AccordionBlock.displayName = "Block::AccordionBlock";
